import { ServerError } from '@apollo/client/errors';

// Without this, Sentry groups on a message naming the GraphQL operation, so one
// rate limit or rejected payload lands as dozens of issues. The operation name
// stays available on the `kind` tag.
export const networkErrorFingerprint = (networkError: unknown): string[] => {
  if (ServerError.is(networkError)) {
    return ['graphql-network-error', `status ${networkError.statusCode}`];
  }

  if (networkError instanceof Error) {
    return ['graphql-network-error', networkError.name];
  }

  return ['graphql-network-error', 'unknown'];
};
